const isEmpty = value =>
  value === undefined
  || value === null
  || value === '';

const join = rules => (value, data) =>
  rules.map(rule => rule(value, data)).filter(error => !!error)[0]; /* first error */

export const email = value => {
  // Very naive regexp
  if (!isEmpty(value) && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return 'E-pasta adrese nepareiza';
  }
  return null;
}

export const required = value => isEmpty(value) ? 'Šis lauks ir obligāts' : null;
export const isTrue = value => !value;


export const match = field =>  (value, data) => {
  if (data) {
    if (value !== data[field]) {
      return 'Lauku vērtības nesakrīt';
    }
  }
  return null;
}

export const createValidator = rules => (data = {}) => {
  const errors = {};
  Object.keys(rules).forEach((key) => {
  // concat enables both functions and arrays of functions
    const rule = join([].concat(rules[key]));
    const error = rule(data[key], data);
    if (error) {
      errors[key] = error;
    }
  })
  return errors;
};


export const minLength = min => value => {
  if (!isEmpty(value) && value.length < min) {
    return `Laukam jāsatur vismaz ${min} sibmoli`
  }
  return null
}

export const maxLength = max => value => {
  if (!isEmpty(value) && value.length > max) {
    return `Laukam jāsatur ne vairāk kā ${max} sibmoli`
  }
}

export const collectionValidator = validator => (data = []) => data.map(validator);



// WEBPACK FOOTER //
// ./src/components/Form/validators.js